import { parseAsBoolean, parseAsString, useQueryStates } from '@/libs/nuqs'

const useCustomerParams = () => {
	const [params, setParams] = useQueryStates({
		customerId: parseAsString,
		createCustomer: parseAsBoolean,
		q: parseAsString,
		sortBy: parseAsString,
		sortDir: parseAsString,
	})

	return { ...params, setParams }
}

export { useCustomerParams }
